
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/lactomama-lactation-granules",
      function () {
        return require("private-next-pages/category/lactomama-lactation-granules.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/lactomama-lactation-granules"])
      });
    }
  